export class ComunicacaoMarketing
{
  public cod?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
